// src/features/landing/presentation/components/HeroSection.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HeroTopNav } from "./HeroTopNav";

/**
 * @param {{
 *  slides: import("../../domain/heroSlide").HeroSlide[],
 *  showHeroNav?: boolean
 * }} props
 */
export function HeroSection({ slides, showHeroNav = true }) {
    const navigate = useNavigate();
    const [index, setIndex] = useState(0);
    const [fadeState, setFadeState] = useState("fade-in"); // 'fade-in' | 'fade-out'

    if (!slides || slides.length === 0) return null;
    const current = slides[index];

    // description 줄바꿈 처리
    const renderDescription = () =>
        current.description.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
                {line}
                <br />
            </React.Fragment>
        ));

    // 공통 이동 함수 (자동/버튼/번호 모두 여기로)
    const goTo = (nextIndex) => {
        if (nextIndex === index) return;
        setFadeState("fade-out");
        setTimeout(() => {
            setIndex((prev) => {
                // 안전하게 범위 안으로
                const len = slides.length;
                if (nextIndex < 0) return len - 1;
                if (nextIndex >= len) return 0;
                return nextIndex;
            });
            setFadeState("fade-in");
        }, 300); // 페이드 아웃 후 인덱스 변경
    };

    const handleScrollButton = (targetId) => {
        if (!targetId) return;
        // targetId가 경로('/about', '/service' 등)인 경우 navigate 사용
        if (targetId.startsWith('/')) {
            navigate(targetId);
        } else {
            // 기존 스크롤 방식 (하위 호환성)
            const el = document.getElementById(targetId);
            if (!el) return;
            const y = el.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: y, behavior: "smooth" });
        }
    };

    // 자동 슬라이드
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (!slides || slides.length === 0) return;
        const timer = setInterval(() => {
            goTo((index + 1) % slides.length);
        }, 5000);
        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index, slides]);

    return (
        <section className={`hero hero--${fadeState}`}>
            {/* 히어로 위 반투명 네브바 */}
            <HeroTopNav visible={showHeroNav} />

            {/* 배경 이미지 + 오버레이 */}
            <div
                className="hero-bg"
                style={{ backgroundImage: `url(${current.image})` }}
            />
            <div className="hero-overlay" />

            {/* 가운데 콘텐츠 */}
            <div className="hero-content">
                <p className="hero-kicker">{current.title}</p>
                <h1 className="hero-title">{current.subtitle}</h1>
                <p className="hero-desc">{renderDescription()}</p>
                <button className="btn-primary hero-button"
                        onClick={() => handleScrollButton(current.targetId)}>
                    {current.buttonText}
                </button>
            </div>

            {/* 오른쪽 숫자 네비게이션 */}
            <div className="hero-index-nav">
                <div className="hero-index-line" />
                {slides.map((s, i) => (
                    <button
                        key={s.id}
                        className={`hero-index-btn ${i === index ? "active" : ""}`}
                        onClick={() => goTo(i)}
                    >
                        {i + 1}
                    </button>
                ))}
            </div>

            {/* 오른쪽 아래 화살표 */}
            <div className="hero-arrows">
                <button
                    className="hero-arrow"
                    onClick={() => goTo(index - 1)}
                    aria-label="이전 슬라이드"
                >
                    ‹
                </button>
                <button
                    className="hero-arrow"
                    onClick={() => goTo(index + 1)}
                    aria-label="다음 슬라이드"
                >
                    ›
                </button>
            </div>
        </section>
    );
}
